<template>
  <div class="testimonial-card">
    <va-card title="Testimonials">
      <div class="testimonial-container" v-for="testimonial in testimonials" :key="testimonial.name">
        <div class="testimonial">
          {{testimonial.testimonial}}
        </div>
        <div class="testimonial-name">
          <div class="five-stars">
            <va-icon name="fa fa-star" />
            <va-icon name="fa fa-star" />
            <va-icon name="fa fa-star" />
            <va-icon name="fa fa-star" />
            <va-icon name="fa fa-star" />
          </div>
          -{{testimonial.name}}
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>

export default {
  name: 'testimonials-card',
  data () {
    return {
      testimonials: [
        {
          name: 'Milla L., Boulder',
          testimonial: 'Nadia is smart, skilled/professional and great pleasure to work with. She can easily teach your dog all the tricks you want it to learn. Great experience!',
        },
        {
          name: 'Katie D., Broomfield',
          testimonial: 'We met Nadia through a local rescue when she helped us conduct a proper introduction between our new pup and our resident dog who is reactive. She has since been our go-to trainer for months as the new dog settles into our household. Her training is not only effective, she educates us on dog behavior and how best to meet our dogs’ needs. There have been many overwhelming moments when I questioned our decision to adopt another dog and each time, she offered support and encouragement. For us, this is what truly sets her apart from other trainers. She is not only knowledgeable but patient, understanding, and enthusiastic. I always leave our sessions feeling empowered and hopeful. We feel so fortunate to have found Nadia and highly recommend Rewarding Dog Training!',
        },
        {
          name: 'Jordin C., Boulder',
          testimonial: 'Nadia is an excellent trainer. My dog was struggling with some behavior issues that were becoming challenging and impacting my dog\'s confidence and happiness. Nadia was patient and took a dog that was not at all happy to see strangers to being excited and willing to greet them! Particularly teaching a method to redirect the energy. I would highly recommend her for any of her services as she really aims to understand the whole situation and psychology of people and dogs. Nadia provided training outdoors when it was nice as well as indoors. Each presented different challenges, but it was nice to have that 1:1 attention. Stock up hotdogs at Costco, because you will need them!',
        },
      ],
    }
  },
}
</script>

<style scoped lang="scss">
.testimonial-card {
  .testimonial-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    text-align: left;
    margin-bottom: 1rem;

    .testimonial-name {
      margin-left: 1.4rem;
      font-style: italic;
      font-size: 1.1rem;
    }
  }
}
</style>
